import styles from './ButtonNeutral.module.scss';

const ButtonNeutral = ({ onClick, children, href }) => {
  // if use LINK  :
  if (href) {
    return (
      <a href={href} className={styles.button}>
        {children}
      </a>
    );
  }

  // if  onClick
  return (
    <button onClick={onClick} className={styles.button} href={href}>
      {children}
    </button>
  );
};

export default ButtonNeutral;
